import { FunctionComponent } from 'preact';
import { Book, Genre } from '@novelizing/types';
import { useInfiniteScroll } from '../../hooks';
import { BooksGrid } from '../BooksGrid';
import './Inklight.css';

async function fetchGenreTopBooks(
  genreId: number,
  offset: number,
  limit: number,
) {
  const response = await fetch(
    `/api/v0/fictions/genre/${genreId}/top?count=${limit}&offset=${offset}`,
  );

  if (!response.ok) {
    throw new Error(
      `Failed to fetch genre top books: ${response.status} ${response.statusText}`,
    );
  }

  const data = await response.json();

  return {
    data: data.fictions,
    total: data.metadata.total,
    count: data.fictions.length,
  };
}

interface InklightProps {
  genre: Genre;
  limit?: number;
}

export const Inklight: FunctionComponent<InklightProps> = ({
  genre,
  limit = 16,
}) => {
  const {
    data: books,
    loading,
    error,
    hasMore,
    lastElementRef: lastBookElementRef,
  } = useInfiniteScroll<Book>(
    (offset, limit) => fetchGenreTopBooks(genre.id, offset, limit),
    { limit },
  );

  if (!genre) {
    return null;
  }

  return (
    <section className="inklight-container">
      {/* <div className="inklight-header">
        <h2 className="inklight-title">Top in {genre.title}</h2>
        <p className="inklight-subtitle">The most popular books in this genre</p>
      </div> */}

      {error && <div className="error-message">{error}</div>}
      {loading && books.length === 0 && (
        <div className="loading-message">Loading top books...</div>
      )}

      <BooksGrid books={books} lastBookElementRef={lastBookElementRef} />

      {hasMore && books.length > 0 && (
        <div className="loading-more">
          {loading ? 'Loading more...' : 'Scroll for more'}
        </div>
      )}
    </section>
  );
};
